import { DEFAULT_PAGE_SIZE, INITIAL_LEAD_FILTERS, PAGE_SIZE_OPTIONS } from "./constants";

export const LEAD_FILTERS_KEY = "crm.leads.filters.v1";
export const LEAD_SEARCH_KEY = "crm.leads.search.v1";
export const LEAD_PAGE_SIZE_KEY = "crm.leads.pageSize.v1";
export const NAV_TOP_KEY = "crm.nav.top.v1";
export const NAV_SIDEBAR_KEY = "crm.nav.sidebar.v1";

export function readStoredTopNav() {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(NAV_TOP_KEY) || "";
  } catch (_e) {
    return "";
  }
}

export function readStoredSidebarItem() {
  if (typeof window === "undefined") return "My Leads";
  try {
    return window.localStorage.getItem(NAV_SIDEBAR_KEY) || "My Leads";
  } catch (_e) {
    return "My Leads";
  }
}

export function writeStoredNav(topNav, sidebarItem) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(NAV_TOP_KEY, topNav);
    window.localStorage.setItem(NAV_SIDEBAR_KEY, sidebarItem);
  } catch (_e) {
    // ignore
  }
}

export function readStoredLeadFilters() {
  if (typeof window === "undefined") {
    return INITIAL_LEAD_FILTERS;
  }

  try {
    const raw = window.localStorage.getItem(LEAD_FILTERS_KEY);
    if (!raw) {
      return INITIAL_LEAD_FILTERS;
    }
    const parsed = JSON.parse(raw);
    return {
      ...INITIAL_LEAD_FILTERS,
      ...(parsed && typeof parsed === "object" ? parsed : {}),
    };
  } catch (_error) {
    return INITIAL_LEAD_FILTERS;
  }
}

export function persistLeadFilters(filters, search) {
  if (typeof window === "undefined") return;

  const filtersToPersist = { ...filters };
  const isDefaultFilters = Object.entries(INITIAL_LEAD_FILTERS).every(
    ([key, value]) => filtersToPersist[key] === value,
  );
  const trimmedSearch = (search || "").trim();

  if (isDefaultFilters && !trimmedSearch) {
    clearStoredLeadFilters();
    return;
  }

  window.localStorage.setItem(LEAD_FILTERS_KEY, JSON.stringify(filtersToPersist));
  window.localStorage.setItem(LEAD_SEARCH_KEY, trimmedSearch);
}

export function readStoredLeadSearch() {
  if (typeof window === "undefined") {
    return "";
  }

  try {
    return window.localStorage.getItem(LEAD_SEARCH_KEY) || "";
  } catch (_error) {
    return "";
  }
}

export function readStoredLeadPageSize() {
  if (typeof window === "undefined") {
    return DEFAULT_PAGE_SIZE;
  }

  try {
    const raw = Number(window.localStorage.getItem(LEAD_PAGE_SIZE_KEY) || DEFAULT_PAGE_SIZE);
    return PAGE_SIZE_OPTIONS.includes(raw) ? raw : DEFAULT_PAGE_SIZE;
  } catch (_error) {
    return DEFAULT_PAGE_SIZE;
  }
}

export function clearStoredLeadFilters() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(LEAD_FILTERS_KEY);
  window.localStorage.removeItem(LEAD_SEARCH_KEY);
  window.localStorage.removeItem(LEAD_PAGE_SIZE_KEY);
}
